"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Dealer_1 = require("../Model/Dealer");
class DealerToDataTransformer {
    /**
     * @inheritDoc
     */
    to(a) {
        // @TODO: Implement when needed.
        return {};
    }
    /**
     * @inheritDoc
     */
    from(data) {
        if (typeof data === "string") {
            return (new Dealer_1.default()).setId(data);
        }
        return new Dealer_1.default()
            .setId(data.externalId)
            .setName(data.name)
            .setCity(data.city)
            .setSearchKey(data.searchKey);
    }
}
exports.default = DealerToDataTransformer;
